// Plans page helper (loaded only on /pages/plans, before pc.js).
// 1. Adds readable copies of the plan's hidden checkout properties so order
//    emails and the admin show them: the week-1 meals (from _pc_first_box) and
//    the excluded ingredients. The hidden _pc_* properties are left untouched;
//    the ledger still reads only those.
// 2. "Add to your first delivery": sides that are Shopify products (channel
//    "side", priced, available) can be added to the plan checkout as their own
//    cart lines. The ledger prices the plan line only, so extra lines don't
//    affect plan activation.
(() => {
  let data = {};
  try { data = JSON.parse(document.getElementById('pc-data')?.textContent || '{}'); } catch (e) { /* no data */ }
  const items = data.items || [];
  const names = Object.fromEntries(items.map((i) => [i.id, i.name]));
  const sides = items.filter((i) => i.channel === 'side' && i.available && i.variantId && i.priceCents != null);
  const picked = {};
  const cad = (c) => `CAD ${(c / 100).toFixed(2)}`;
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function renderSides() {
    const anchor = document.querySelector('[data-signup] [data-firstbox]');
    if (!anchor || !sides.length || document.querySelector('[data-first-sides]')) return;
    const fs = document.createElement('fieldset');
    fs.className = 'field';
    fs.setAttribute('data-first-sides', '');
    fs.innerHTML = `<legend>Add to your first delivery <span class="muted small">(optional)</span></legend>
      <p class="small muted">Sides arrive with your first box and are paid at checkout with your plan.</p>
      <div style="display:grid;gap:10px">${sides.map((i) => `
        <div style="display:grid;grid-template-columns:56px 1fr auto;gap:12px;align-items:center;padding:10px;border:1px solid var(--line);border-radius:14px;background:var(--paper)">
          ${i.img ? `<img src="${esc(i.img)}" alt="" width="56" height="56" loading="lazy" style="width:56px;height:56px;border-radius:10px;object-fit:cover">` : '<span></span>'}
          <span style="display:grid;gap:2px;font-weight:600">${esc(i.name)}<small class="muted" style="font-weight:500">${cad(i.priceCents)} each</small></span>
          <div class="qty" data-side="${esc(i.id)}"><button type="button" data-d="-1" aria-label="Remove one ${esc(i.name)}" disabled>−</button><output>0</output><button type="button" data-d="1" aria-label="Add one ${esc(i.name)}">+</button></div>
        </div>`).join('')}</div>
      <p class="small" data-sides-total hidden></p>`;
    anchor.after(fs);
    fs.addEventListener('click', (e) => {
      const b = e.target.closest('.qty button'); if (!b) return;
      const q = b.closest('[data-side]'); const id = q.dataset.side;
      const n = Math.max(0, Math.min(20, (picked[id] || 0) + Number(b.dataset.d)));
      if (n) picked[id] = n; else delete picked[id];
      q.querySelector('output').textContent = n;
      q.querySelector('[data-d="-1"]').disabled = !n;
      const total = sides.reduce((a, i) => a + (picked[i.id] || 0) * i.priceCents, 0);
      const t = fs.querySelector('[data-sides-total]');
      t.hidden = !total; t.textContent = total ? `Sides: ${cad(total)}, added at checkout on top of your plan.` : '';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderSides); else renderSides();

  const orig = window.fetch;
  window.fetch = function (input, init) {
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.includes('/cart/add') && init && typeof init.body === 'string') {
        const body = JSON.parse(init.body);
        let changed = false;
        let isPlan = false;
        for (const it of body.items || []) {
          const p = it.properties;
          if (!p || !p._pc_plan || !p._pc_first_box) continue;
          isPlan = true;
          const meals = String(p._pc_first_box).split(',')
            .map((x) => x.split(':'))
            .filter(([id]) => id)
            .map(([id, q]) => `${q || 1} x ${names[id] || id}`);
          if (meals.length) { p['Week 1 meals'] = meals.join(' | '); changed = true; }
          if (p._pc_exclusions) { p['Leave out'] = String(p._pc_exclusions).split(',').join(', '); changed = true; }
        }
        if (isPlan) {
          for (const i of sides) {
            if (!picked[i.id]) continue;
            body.items.push({ id: Number(i.variantId), quantity: picked[i.id], properties: { 'Delivered with': 'First plan delivery' } });
            changed = true;
          }
        }
        if (changed) init = Object.assign({}, init, { body: JSON.stringify(body) });
      }
    } catch (e) { /* never block the cart call */ }
    return orig.call(this, input, init);
  };
})();
